"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderByType;
(function (OrderByType) {
    OrderByType["ASC"] = "ASC";
    OrderByType["DESC"] = "DESC";
})(OrderByType = exports.OrderByType || (exports.OrderByType = {}));
//# sourceMappingURL=OrderByType.js.map